import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';

// 导入页面组件
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import Dashboard from './pages/Dashboard';
import ReportList from './pages/ReportList';
import ReportReview from './pages/ReportReview';
import ReportView from './pages/ReportView';
import AppointmentOrdersQueue from './pages/AppointmentOrdersQueue';
import ClinicReportView from './pages/ClinicReportView';
import ReviewedReportsList from './pages/ReviewedReportsList';
import DoctorList from './pages/DoctorList';
import UserCenter from './pages/UserCenter';
import AdminDebugDemo from './pages/AdminDebugDemo';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

// 动态标题更新组件
const TitleUpdater = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const getPageTitle = () => {
      const path = location.pathname;
      let pageTitle = t('dashboard.title');
      
      if (path === '/') {
        pageTitle = t('dashboard.title');
      } else if (path === '/login') {
        pageTitle = t('auth.loginTitle');
      } else if (path === '/admin-login') {
        pageTitle = t('dashboard.adminLogin');
      } else if (path.startsWith('/reviewed-reports')) {
        pageTitle = t('reports.reviewedReports');
      } else if (path.startsWith('/reports') && path.includes('/review')) {
        pageTitle = t('reports.reviewTitle');
      } else if (path.startsWith('/reports') && path.includes('/view')) {
        pageTitle = t('reports.viewReport');
      } else if (path.startsWith('/reports')) {
        pageTitle = t('reports.pendingReports');
      } else if (path.startsWith('/appointment-orders')) {
        pageTitle = i18n.language.startsWith('zh') ? '复诊预约单' : 'Appointment Orders';
      } else if (path.startsWith('/doctors')) {
        pageTitle = t('dashboard.doctorManagement');
      } else if (path.startsWith('/clinic/reports')) {
        pageTitle = t('reports.clinicReportView');
      } else if (path.startsWith('/user-center')) {
        pageTitle = t('dashboard.userCenter');
      } else if (path.startsWith('/admin/debug-demo')) {
        pageTitle = t('debugDemo.title');
      }
      
      document.title = `${pageTitle} - AI Clinic`;
    };

    getPageTitle();
  }, [location.pathname, t, i18n.language]);

  return null;
};

function App() {
  return (
    <Router basename="/web">
      <Layout>
        <div className="App">
          <TitleUpdater />
          <Routes>
            {/* 公开路由 */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/" element={<Dashboard />} />
            
            {/* 需要医生权限的路由 */}
            <Route path="/reports" element={
              <PrivateRoute>
                <ReportList />
              </PrivateRoute>
            } />
            <Route path="/reviewed-reports" element={
              <PrivateRoute>
                <ReviewedReportsList />
              </PrivateRoute>
            } />
            <Route path="/appointment-orders" element={
              <PrivateRoute>
                <AppointmentOrdersQueue />
              </PrivateRoute>
            } />
            <Route path="/reports/:id/review" element={
              <PrivateRoute>
                <ReportReview />
              </PrivateRoute>
            } />
            <Route path="/reports/:id/view" element={
              <PrivateRoute>
                <ReportView />
              </PrivateRoute>
            } />
            <Route path="/user-center" element={
              <PrivateRoute>
                <UserCenter />
              </PrivateRoute>
            } />
            <Route path="/doctors" element={<DoctorList />} />
            <Route path="/admin/debug-demo" element={<AdminDebugDemo />} />

            {/* 诊所通过token查看报告 (公开路由，使用token参数进行验证) */}
            <Route path="/clinic/reports/:id" element={<ClinicReportView />} />
            
            {/* 其他未知路由重定向到根路由 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Layout>
    </Router>
  );
}

export default App; 
